import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import ControllerError from "./controller-error.js";
import ErrorBoundary from "./error-boundary.js";
import { useFormViewerContext } from "./form-viewer-context.js";
import Widget from "./widget.js";
const FormViewerLean = forwardRef(
  ({
    i18n,
    formId,
    stepId,
    values,
    onChange,
    onBlur,
    onFocus,
    onStepIdChange,
    errors,
    onValidate,
    onError,
    externalData,
    overrides,
    bi,
    biFormFillSessionId,
    forcedState,
    httpClient,
    onSubmit,
    onSubmitSuccess,
    onSubmitFailure,
    fields,
    WixRicosViewer,
    panorama
  }, forwardedRef) => {
    const { host, controller } = useFormViewerContext();
    return /* @__PURE__ */ jsx(
      ErrorBoundary,
      {
        host,
        wfConfig: controller.wfConfig,
        onError,
        children: /* @__PURE__ */ jsx(ControllerError, { wfConfig: controller.wfConfig, onError, children: /* @__PURE__ */ jsx(
          Widget,
          {
            httpClient,
            i18n,
            bi,
            biFormFillSessionId,
            formId,
            values,
            stepId,
            onChange,
            onBlur,
            onFocus,
            onStepIdChange,
            errors,
            onValidate,
            forwardedRef,
            controller,
            onError,
            externalData,
            overrides,
            forcedState,
            fields,
            WixRicosViewer,
            onSubmit,
            onSubmitSuccess,
            onSubmitFailure,
            panorama
          }
        ) })
      }
    );
  }
);
export {
  FormViewerLean as default
};
//# sourceMappingURL=form-viewer-lean.js.map
